export default __webpack_public_path__ + "static/media/static_img_commonocean_logo_white.5b268ba3.svg";